
import { ChangeEvent,  useState } from "react";

import { getAllLog } from "./service";
import {  debounce, Divider,  Paper, Table, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import { useQuery } from "react-query";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { SearchParamsType } from "../../CinicManagement/types";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import { clinicId } from "../../../constants";
function LogHistory() {
    const pageTitle = "Search Log History";
    const [searchParams, setSearchParams] = useState<SearchParamsType>({
        pageNumber: 0,
        pageSize: 25,
        filter: {
            searchText: "",
            status: 2,
            searchDate:"",
        },
        sortField: "",
        sortOrder: "",
        clinicId: clinicId, // Assuming clinicId is 1 for this example
    });



    const {
        data: tableData,
        isLoading: tableDataLoading,
  
    } = useQuery(
        ["", searchParams],
        async () => getAllLog(searchParams),
        {
            refetchOnWindowFocus: false,
        }
    );

    

    const handleChangePage = (
        _: React.MouseEvent<HTMLButtonElement> | null,
        pageNumber: number
    ) => {
        setSearchParams((prev) => ({
            ...prev,
            pageNumber,
        }));
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setSearchParams((prev) => ({
            ...prev,
            page: 0,
            pageSize: parseInt(event.target.value, 10),
        }));
    };

  

    const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchParams((prev) => ({
            ...prev,
            filter:{
                ...prev.filter,
                searchText: e.target.value
            }
        }));
    };
    const debounceSearch = debounce(handleSearchChange, 500);

    return (
        <div className="p-3">
            <Paper>
                <div className="flex justify-between p-3">
                    <div className="flex gap-2">
                        <Typography variant="h6" color={"default"}>
                            {pageTitle} Master
                        </Typography>
                    </div>
                </div>
                <Divider />
                <div className="">
                    <div className="grid grid-cols-4 gap-3 py-3 px-2">
                        <TextField label={"Search"} onChange={debounceSearch} />

                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                            <DatePicker
                                label="Search Date"
                                format="DD-MM-YYYY"
                                value={
                                    searchParams.filter.searchDate
                                        ? dayjs(searchParams.filter.searchDate, "DD-MM-YYYY")
                                        : null
                                }
                                onChange={(date) =>
                                    setSearchParams((prev) => ({
                                        ...prev,
                                        filter: {
                                            ...prev.filter,
                                            searchDate: date
                                                ? dayjs(date).format("DD-MM-YYYY")
                                                : "",
                                        },
                                    }))
                                }
                                slotProps={{
                                    textField: { size: "small", fullWidth: true }
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <TableContainer className="border">
                        <Table stickyHeader size="small">
                            <TableHead>
                                <TableRow>
                                    
                                    {headings.map((heading) => (
                                        <TableCell key={heading} className="font-bold">
                                            {heading}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <CustomTableBody
                                alert={"No data"}
                                dataLoading={tableDataLoading}
                                isData={Boolean(tableData?.response?.items?.length)}
                                totalSpan={{
                                    row: searchParams.pageSize,
                                    col: headings.length + 1,
                                }}
                            >
                                {tableData?.response?.items?.map((tableItem, index) => (
                                    <TableRow key={`${pageTitle}-${index}`}>
                                        <TableCell>{index + 1 + searchParams.pageNumber * searchParams.pageSize}</TableCell>
                                         <TableCell>{tableItem?.userName}   </TableCell>
                                         <TableCell> {tableItem?.designation}  </TableCell>
                                         <TableCell> {tableItem?.createdDate}  </TableCell>
                                         <TableCell> {tableItem?.action}  </TableCell>
                                         <TableCell> {tableItem?.description}  </TableCell>
                                    </TableRow>
                                ))}
                            </CustomTableBody>
                        </Table>
                        <div className="flex justify-end">
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component={"div"}
                                count={tableData?.response?.totalcount || 0}
                                rowsPerPage={searchParams.pageSize}
                                page={searchParams.pageNumber}
                                sx={{ border: 0 }}
                                slotProps={{
                                    select: {
                                        inputProps: {
                                            "aria-label": "rows per page",
                                        },
                                        native: true,
                                    },
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            // ActionsComponent={TablePaginationActions}
                            />
                        </div>
                    </TableContainer>
                </div>
            </Paper>
        </div>
    );
}
export default LogHistory;



const headings = [
    "sl No",
    "UserName",
    "Designation",
    "Date & Time",
    "Action",
    "Description",
]